export var IdFortuneTellerEvent;
(function (IdFortuneTellerEvent) {
    IdFortuneTellerEvent[IdFortuneTellerEvent["BuyPackageCoolDownTime"] = 3] = "BuyPackageCoolDownTime";
    IdFortuneTellerEvent[IdFortuneTellerEvent["TwinklingStarsCount"] = 10] = "TwinklingStarsCount";
})(IdFortuneTellerEvent || (IdFortuneTellerEvent = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdFortuneTellerEvent.ts
// module id = 595
// module chunks = 3